import classNames from 'classnames'
import { FC, memo } from 'react'

export type CrewDividerProps = {
  className?: string
}

export const CrewDivider: FC<CrewDividerProps> = memo((props) => (
  // 表示領域内で両端に余白を持たせるためpx-2を指定する
  <div className={classNames('px-2', props.className)}>
    <div className="h-0 border-b crew-border-gray"></div>
  </div>
))
